import { render, staticRenderFns } from "./CampaignShare.vue?vue&type=template&id=5a12e6b5&scoped=true&"
import script from "./CampaignShare.vue?vue&type=script&lang=js&"
export * from "./CampaignShare.vue?vue&type=script&lang=js&"
import style0 from "./CampaignShare.vue?vue&type=style&index=0&id=5a12e6b5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a12e6b5",
  null
  
)

export default component.exports